import {
	RemoveVerifyContainerMutation,
	SubmitOrderVerificationMutation,
	SubmitVerifyContainerMutation
} from "~/gql/mutations/verify.generated";
import { GetOrderVerificationComparisonQuery, GetVerifyOrderVerificationQuery } from "~/gql/queries/verify.generated";
import isNoChangesError from "~/helpers/isNoChangesError";
import { isQueuedNetworkFailure } from "~/helpers/offline/classifyMutationFireOutcome";
import { isFinalVerifyRefusalCode } from "~mobile/verify/helpers/verifyRefusal";

const isRetryableRefusal = (result: SubmitOrderVerificationMutation | undefined): boolean => {
	const errors = result?.submitOrderVerification?.errors ?? [];
	return errors.length > 0 && !errors.some((error) => isFinalVerifyRefusalCode(error.code));
};

const isRefusedRemoval = (result: RemoveVerifyContainerMutation | undefined): boolean => {
	const errors = result?.removeVerifyContainer?.errors ?? [];
	return errors.length > 0 && !isNoChangesError(null, errors);
};

export const verifyEndpoints = {
	GetOrderVerificationComparison: {
		providesTags: ["VerifyContainers"] as AddTagTypes,
		transformResponse: (res: GetOrderVerificationComparisonQuery) => res
	},
	GetVerifyOrderVerification: {
		providesTags: ["VerifyOrderVerification"] as AddTagTypes,
		transformResponse: (res: GetVerifyOrderVerificationQuery) => res
	},
	RemoveVerifyContainer: {
		invalidatesTags: (result: RemoveVerifyContainerMutation | undefined, error: unknown) =>
			error || isRefusedRemoval(result) ? [] : ["VerifyContainers" as const, "VerifyOrderVerification" as const],
		transformResponse: (res: RemoveVerifyContainerMutation) => res
	},
	SubmitOrderVerification: {
		invalidatesTags: (result: SubmitOrderVerificationMutation | undefined, error: unknown) =>
			(error && !isQueuedNetworkFailure(error)) || isRetryableRefusal(result)
				? []
				: ["VerifyContainers" as const, "VerifyOrderVerification" as const],
		transformResponse: (res: SubmitOrderVerificationMutation) => res
	},
	SubmitVerifyContainer: {
		invalidatesTags: ["VerifyOrderVerification"] as AddTagTypes,
		transformResponse: (res: SubmitVerifyContainerMutation) => res
	}
};
